import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CancelIcon from "@mui/icons-material/Cancel";

import PrimaryButton from "../../../widgets/Buttons/PrimaryButton";
import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import routes from "../../../constants/routes";
import styles from "../StudentDetails.module.scss";

const getRegionQueryString = (search) => {
  const currentParams = new URLSearchParams(search);
  const regionParams = new URLSearchParams();
  const countryId = currentParams.get("countryId");
  const isdCode = currentParams.get("isdCode");

  if (countryId) {
    regionParams.set("countryId", countryId);
  }
  if (isdCode) {
    regionParams.set("isdCode", isdCode);
  }

  const query = regionParams.toString();
  return query ? `?${query}` : "";
};

const OrderManagementCard = ({ uamId, phone, vertical }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleManageOrder = () => {
    if (!uamId) return;
    navigate(
      `${routes.modifyOrder.replace(":studentId", uamId)}${getRegionQueryString(location.search)}`,
      {
        state: { uamId, phone, vertical },
      },
    );
  };

  const handleCancelOrder = () => {
    if (!uamId) return;
    navigate(
      `${routes.cancelOrder.replace(":studentId", uamId)}${getRegionQueryString(location.search)}`,
      {
        state: { uamId, phone, vertical },
      },
    );
  };

  return (
    <>
      <PrimaryButton
        className={`${styles.actionButtonLarge} ${styles.actionButtonNeutral}`}
        startIcon={<ReceiptIcon />}
        onClick={handleManageOrder}
      >
        Order Modification
      </PrimaryButton>
      <SecondaryButton
        className={`${styles.actionButtonLarge} ${styles.actionButtonNeutral}`}
        startIcon={<CancelIcon />}
        onClick={handleCancelOrder}
      >
        Order Cancellation
      </SecondaryButton>
    </>
  );
};

export default OrderManagementCard;
